import Vue from 'vue'
import Router from 'vue-router'
import {routes, routeInterupter} from '@/router/routes'
Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  routeInterupter(to, from, next)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js